import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const PlatformRepository = RepositoryFactory.get('RailwayRepository')['PlatformRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create, update, remove } = DefaultStoreActions(PlatformRepository)

export const STORE_MODULE_NAME = 'platform';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
